export type BannerMode = 'guest' | 'free' | 'paid';

const EARLY_ACCESS_CODES = new Set(['EARLY_ACCESS', 'DEV_BYPASS', 'OPERATOR_BYPASS']);

export const isEarlyAccessPlan = (
  planCode?: string | null,
  planDisplayName?: string | null
): boolean => {
  if (!planCode && !planDisplayName) return true;

  const normalizedCode = planCode?.toUpperCase();
  if (normalizedCode && EARLY_ACCESS_CODES.has(normalizedCode)) return true;

  const normalizedName = planDisplayName?.toLowerCase();
  return normalizedName?.includes('early access') ?? false;
};

export const resolveBannerMode = (
  isAuthenticated: boolean,
  planCode?: string | null,
  planDisplayName?: string | null
): BannerMode => {
  if (!isAuthenticated) return 'guest';

  if (isEarlyAccessPlan(planCode, planDisplayName)) return 'free';

  return 'paid';
};

export const planLabels = (planCode?: string | null) => {
  switch (planCode?.toUpperCase()) {
    case 'STARTER':
      return { packLimitLabel: '5 packs/month', retentionLabel: '7-day retention' };
    case 'GROWTH':
      return { packLimitLabel: '25 packs/month', retentionLabel: '30-day retention' };
    case 'ENTERPRISE':
      return { packLimitLabel: 'Unlimited packs/month', retentionLabel: '90-day retention' };
    case 'EARLY_ACCESS':
    default:
      return { packLimitLabel: '0 packs/month', retentionLabel: 'no long-term retention' };
  }
};
